// isPrerender — true ONLY while scripts/prerender.js is capturing static HTML
// at build time. The script sets `window.__PRERENDER__ = true` via
// evaluateOnNewDocument before the app boots.
//
// NOTE: this deliberately does NOT use navigator.webdriver — headless
// browsers in general (Lighthouse, screenshot tools, some bots) also set
// webdriver, and freezing visual state for them would render blank pages.
//
// Why this exists: React 19 hydration compares the static HTML against the
// client's FIRST render (before any effects). Effects that mutate the DOM on
// mount — reveal animations, counters, measure-then-show logic, one-off logo
// draw states — would bake their POST-effect state into the static HTML and
// trigger hydration error #418. Guarding those effects with isPrerender()
// keeps the captured HTML byte-identical to the client's initial render;
// the effects then run normally for real visitors right after hydration.
export const isPrerender = () =>
  typeof window !== 'undefined' && !!window.__PRERENDER__;
